<template>
  <div class="input-group">
    <v-row>
      <v-col cols="4" sm="4" md="4" lg="4" class="p-t-0">
        For each object in
      </v-col>
      <v-col cols="7" sm="7" md="7" lg="7" class="p-t-0 p-b-10">
        <v-text-field
          class="m-auto shift-m-t"
          v-model="property.variable"
          label="Array variable"
          hint="For example, ${api.data.*}"
          dense
          @keyup.down="pressDown"
          @keyup.up="pressUp"
          @keydown.enter="onEnter"
          @keydown.tab="pressTab"
        ></v-text-field>
        <!-- === use for Intellisense ===-->
        <intellisense-component
          :input="property.variable"
          :drawFlowItems="drawFlowItems"
          :property="'variable'"
          :apiForIntellisense="apiForIntellisense"
          :start="start"
          :eventKey="eventKey"
          @clearSelected="clearSelected"
          @updateInputFromIntellisense="updateInputFromIntellisense"
        />
        <!-- === use for Intellisense ===-->
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4" sm="4" md="4" lg="4">
        Run page
      </v-col>
      <v-col cols="7" sm="7" md="7" lg="7" class="d-flex">
        <v-select
          class="m-auto shift-m-t"
          v-model="property.page"
          :items="tabFilter"
          item-text="name"
          item-value="id"
          label="Page"
          dense
          hide-details
        ></v-select>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              v-bind="attrs"
              v-on="on"
              class="m-l-10"
              :disabled="!property.page"
              @click="goToPage(property.page)"
            >
              fa-arrow-up-right-from-square
            </v-icon>
          </template>
          <span>Open page</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4" sm="4" md="4" lg="4">
        Loop
      </v-col>
      <v-col cols="7" sm="7" md="7" lg="7">
        <v-radio-group v-model="property.isLimit" row hide-details>
          <v-radio :value="false" class="margin-radio" key="limit-false">
            <template v-slot:label>
              <div class=" font-size-body">
                <div class="m-auto width100px">
                  All objects in array
                </div>
              </div>
            </template>
          </v-radio>
          <v-radio :value="true" class="margin-radio" key="limit-true">
            <template v-slot:label>
              <div class="display-flex font-size-body">
                <div class="m-auto width80px">
                  Limit to first
                </div>
                <div class="m-l-10">
                  <v-text-field
                    v-model="property.limit"
                    :disabled="!property.isLimit"
                    type="number"
                    class="margin0 padding0 width70px"
                    dense
                    hide-details
                    @blur="blurOpertion"
                  ></v-text-field>
                </div>
              </div>
              <div class="m-l-10">objects</div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="p-b-0">
        <div class="m-t-10">
          Loop component allows flow to loop through array of objects and run
          the specified page on each iteration. You can reference to these
          variables to access the array.
        </div>
        <div class="m-l-15">
          <div v-for="(desc, index) in description" :key="index">
            {{ desc }}
          </div>
        </div>
      </v-col>
    </v-row>

    <hr class="note-divider" />
    <note-component :node="node" />
  </div>
</template>

<script>
import _ from 'lodash'

import NoteComponent from '../../../components/note'
// === use for Intellisense ===
import IntellisenseComponent from '../../../components/intellisense'
// === use for Intellisense ===
export default {
  props: {
    node: Object,
    tabs: Array,
    currentTab: String,
    drawFlowItems: Object,
    apiForIntellisense: Object
  },
  components: {
    NoteComponent,
    // === use for Intellisense ===
    IntellisenseComponent
    // === use for Intellisense ===
  },
  data() {
    return {
      property: {},
      tabFilter: [],
      loopTypes: [
        {
          label: 'All objects in array',
          value: false
        },
        {
          label: 'Limit',
          value: true
        }
      ],
      description: [
        '${system.loop.current} - Current object',
        '${system.loop.index} - Current index (starting from 0)',
        '${system.loop.order} - Current order sequence (starting from 1)',
        '${system.loop.length} - Total number of objects in array'
      ],
      // === use for Intellisense ===
      start: -1,
      isKeyTab: false,
      eventKey: ''
      // === use for Intellisense ===
    }
  },
  watch: {
    'property.page': {
      handler(value) {
        const item = _.find(this.tabs, { id: value })
        if (item) {
          this.node.name = item.name
        }
      }
    }
  },
  created() {
    this.property = this.node.property

    const tabFilter = _.filter(
      this.tabs,
      o => o.name !== 'Home' && o.name !== this.currentTab //&& o.type !== 'terminal'
    )

    this.tabFilter = _.sortBy(tabFilter, [
      function(o) {
        return o.name
      }
    ])
  },
  methods: {
    goToPage(pageId) {
      this.$emit('goToPage', pageId)
    },
    blurOpertion() {
      this.property.limit = isNaN(this.property.limit)
        ? 0
        : Math.abs(this.property.limit)
    },
    // === use for Intellisense ให้ keyup keyDown ได้ ===
    pressDown() {
      this.start += 1
      this.eventKey = 'keydown'
    },
    pressUp() {
      this.start -= 1
      this.eventKey = 'keyup'
    },
    pressTab() {
      this.isKeyTab = true
      this.start = -1
    },
    onEnter() {
      this.start = -1
      this.eventKey = 'enter'
    },
    clearSelected() {
      this.start = -1
    },
    updateInputFromIntellisense(property, data) {
      this.property.variable = data
    }
    // === use for Intellisense ให้ keyup keyDown ได้ ===
  }
}
</script>
<style scoped lang="scss">
::v-deep .v-messages__message {
  font-size: 10px;
}

.no-margin-top {
  margin-top: 0px !important;
}

.width70px {
  // text-align: right !important;
  width: 70px;
}

.width80px {
  // text-align: right !important;
  width: 80px;
}
</style>
